import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { getBrandConfig } from "@/config/brand";

interface PublicFooterProps {
  className?: string;
}

export const PublicFooter = ({ className }: PublicFooterProps) => {
  const { t } = useTranslation();

  return (
    <footer
      className={cn(
        "relative border-t border-border/60 bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/70",
        className
      )}
    >
      <div className="container mx-auto flex flex-col gap-3 px-4 py-6 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <p>&copy; {new Date().getFullYear()} {getBrandConfig().brandName}</p>
        <div className="flex flex-wrap items-center gap-4">
          <Link
            to="/privacy-policy"
            className="transition-colors hover:text-foreground hover:underline hover:underline-offset-4"
          >
            {t("footer.privacyPolicy")}
          </Link>
          <Link
            to="/terms-of-use"
            className="transition-colors hover:text-foreground hover:underline hover:underline-offset-4"
          >
            {t("footer.termsOfUse")}
          </Link>
        </div>
      </div>
    </footer>
  );
};
